<a [href]="mobiliarPartnershipPage" class="inline-block w-fit" bgoOpenNewTab *transloco="let t">
  <div
    class="mx-auto flex w-fit cursor-pointer flex-col items-center justify-center gap-2xs rounded-lg border border-gold-500 bg-white px-md py-sm text-president-500 hover:shadow-2 md:flex-row"
  >
    <p class="whitespace-nowrap">{{ t('shared.mobiPartnership.title') }}</p>
    <bgo-mobiliar-logo [hasLink]="false" size="xs"></bgo-mobiliar-logo>
  </div>
</a>
